module.exports = __webpack_public_path__ + "static/media/close-button.10d85fda.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/close-button.svg
 ** module id = 125
 ** module chunks = 0
 **/